import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfigService } from '../core/services/config.service';
import { EnumHttp, EnumStatus } from '../core/models/enum';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  submitted: boolean = false;
  loginForm!: UntypedFormGroup;
  versionCode:string = "";
  imgBgAuth = Math.random() >= .5 ? 1 : 2;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public configService: ConfigService,
    private router: Router,
  ) {
    if(this.configService.checkToken()){ this.router.navigate(['/dashboard']); }
    this.versionCode = this.configService.Version;
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });

  }
  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }
  /**
   * Form submit
   */
  onSubmit() {
    this.submitted = true;
    this.configService.sendReq(this.configService.url.Login, this.loginForm.value, EnumHttp.Post, (res) =>{
      this.submitted = false;
      if(res.code == EnumStatus.Success){
        this.configService.showAlert("Login Success", "", "success", 1500, () => {
          this.loginForm.reset();
          this.router.navigate(['/dashboard']);
        });
      }
    }, true)
  }
}
